import React, { Component } from 'react'
import injectSheet from 'react-jss'
import { flexUtils } from '../../Theme/Theme'
// import ReactGA from 'react-ga'
import { palette } from '../../Theme/Theme'
import Color from 'color'
import { Link } from 'react-router-dom'
import TagManager from 'react-gtm-module'
// import Responsive from 'react-responsive'

// const Desktop = props => <Responsive {...props} minWidth={736} />
// const Tablet = props => <Responsive {...props} minWidth={736} maxWidth={1024}/>
// const Mobile = props => <Responsive {...props} maxWidth={735} />

class Logo extends Component {
  render () {
    const { classes } = this.props
    return (
      <React.Fragment>
        <div className={classes.LogoContainer}>
          <img src="../../../Assets/spectiv_tune_r.png" alt='' className={classes.SpectivLogo}/>
          {/* <Link to="/welcome/browse" style={{textDecoration: 'none'}} className={classes.buttonContainer}>
            <div className={classes.button}>
                Browse
            </div>
          </Link> */}
        </div>
      </React.Fragment>
    )
  }

  componentDidMount () {
    // ReactGA.pageview('/welcome')
    TagManager.dataLayer({
      dataLayer: {
          event: 'PageView',
          page: '/welcome',
      }
    })
  }
}

const styles = {
  ...flexUtils,
  LogoContainer: {
    composes: ['$FlexColumn', '$FlexCenter'],
    height: '75vh',
    width: '100vw',
    marginTop: '10vh',
    zIndex: '0'
  },
  SpectivLogo: {
    position: 'relative',
    top: '-5rem',
    width: '40%',
    minWidth: '18rem'
  },
  buttonContainer: {
    transition: 'all .4s',
    backgroundColor: palette.blue,
    width: '10vw',
    minWidth: '8rem',
    minHeight: '2rem',
    height: '5vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '5px',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: Color(palette.blue).darken(0.2).toString()
    }
  },
  button: {
    color: palette.white,
    fontWeight: '500',
    fontSize: '1.5rem'
  }
}

export default injectSheet(styles)(Logo)



// WEBPACK FOOTER //
// ./src/js/Components/LandingPage/Logo.jsx